import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { FileDownloadOutlined, Share } from "@mui/icons-material";
import useCompra from "./useCompra";
import Loading from "../../../Loading";
import { downloadTicketPDF, downloadVoucherPDF } from "../api";
import TicketShareModal from "../../../modales/TicketShareModal";
import withAuthenticationRequired from "../../../ProtectedRoutes/withAuthenticationRequired";
import BarraCompra from "../../../compras/BarraCompra";
import ItemsCompra from "../../../compras/ItemsCompra";

const PRIMARIO = "#5656FF";

const botonSx = {
  padding: "5px 10px",
  borderRadius: 4,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 14,
  width: "100%",
};

const nombreArchivo = (...partes) => partes.map((p) => String(p).replace(/\s+/g, "_")).join("_") + ".pdf";

const Compra = () => {
  const { id } = useParams();
  const history = useHistory();
  const { compra, loading, unauthorized } = useCompra(id);
  const [descargando, setDescargando] = useState({});
  const [compartiendo, setCompartiendo] = useState(null); // { id, tipo }

  if (unauthorized) return null;
  if (loading) return <Loading />;

  const eventoNombre = compra?.carrito?.evento?.evento || "Evento";
  const clave = (tipo, itemId) => `${tipo}-${itemId}`;
  const itemDe = (tipo, itemId) => (tipo === "voucher" ? compra?.vouchers : compra?.tickets)?.find((i) => i.id === itemId);

  const descargar = async (e, item, tipo) => {
    e.stopPropagation();
    setDescargando((d) => ({ ...d, [clave(tipo, item.id)]: true }));
    try {
      const pdf = await (tipo === "voucher" ? downloadVoucherPDF(item.id) : downloadTicketPDF(item.id));
      const url = window.URL.createObjectURL(pdf);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreArchivo(eventoNombre, item.tarifa?.concepto || tipo, item.id));
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Error al descargar el ${tipo}:`, error);
    } finally {
      setDescargando((d) => ({ ...d, [clave(tipo, item.id)]: false }));
    }
  };

  const acciones = (item, tipo) => {
    const bajando = descargando[clave(tipo, item.id)];
    return (
      <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
        <button
          type="button"
          onClick={(e) => descargar(e, item, tipo)}
          style={{ ...botonSx, border: `1px solid ${PRIMARIO}`, color: PRIMARIO, opacity: bajando ? 0.7 : 1 }}
        >
          {bajando ? (
            <><CircularProgress size={16} sx={{ color: PRIMARIO, mr: "4px" }} /> Descargando...</>
          ) : (
            <><FileDownloadOutlined fontSize="small" style={{ marginRight: 4 }} /> Descargar</>
          )}
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setCompartiendo({ id: item.id, tipo });
          }}
          style={{ ...botonSx, backgroundColor: PRIMARIO, color: "white" }}
        >
          <Share fontSize="small" style={{ marginRight: 4 }} /> Compartir
        </button>
      </div>
    );
  };

  const itemCompartido = compartiendo && itemDe(compartiendo.tipo, compartiendo.id);

  return (
    <div className="container-fluid container-sm mx-auto mt-1 mb-5">
      <BarraCompra compraId={compra?.id} etiqueta="Evento" valor={eventoNombre} onVolver={() => history.push("/mis-compras")} />

      <ItemsCompra compra={compra} renderAcciones={acciones} />

      {compartiendo && (
        <TicketShareModal
          open
          setShareModalOpen={(abierto) => !abierto && setCompartiendo(null)}
          onClose={() => setCompartiendo(null)}
          ticketId={compartiendo.id}
          itemType={compartiendo.tipo}
          eventoNombre={eventoNombre}
          ticketTipo={itemCompartido?.tarifa?.concepto || (compartiendo.tipo === "voucher" ? "Voucher" : "Ticket")}
          ticketName={itemCompartido?.nombre}
        />
      )}
    </div>
  );
};

export default withAuthenticationRequired(Compra, {
  onRedirecting: () => <Loading />,
});
